import {
  DeleteAgencyCustomerRequestPathParamType,
  DeleteAgencyCustomerResponseBodyType,
} from "@intelligems/ig-types";
import { adminKeys } from "@src/api/queryKeys";
import { ApiRequest } from "@src/api/types/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const deleteAgencyCustomer = async (
  data: ApiRequest<any, DeleteAgencyCustomerRequestPathParamType>
) => {
  const resp = await api.delete<DeleteAgencyCustomerResponseBodyType>(
    `/v2/admin/customers/${data.pathParams.id}`
  );
  return resp.data;
};

export const useDeleteAgencyCustomer = (agencyId: string) => {
  const queryClient = useQueryClient();
  return useMutation<
    DeleteAgencyCustomerResponseBodyType,
    Error,
    ApiRequest<any, DeleteAgencyCustomerRequestPathParamType>,
    any
  >({
    mutationFn: async (data) => deleteAgencyCustomer(data),
    onSuccess: (data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: adminKeys.agencyCustomers(agencyId),
      });
      void queryClient.invalidateQueries({
        queryKey: adminKeys.agency(agencyId),
      });
    },
  });
};
